import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DefaultObservationType, IObservationType } from 'src/Definitions';
import { Client, IObservationTypeDto, SwaggerResponse } from 'src/generated_client';
import DataTableStore from '../DataTableStore';

export default class ObservationTypesStore {
    @observable
    public isLoading: boolean = false;
    @observable
    public isModalOpen: boolean;
    @observable
    public observationTypes: IObservationType[];
    @observable
    public selectedObservationType?: IObservationTypeDto;
    public dataTableStore: DataTableStore<IObservationTypeDto, IObservationType>;

    constructor(private client: Client) {}

    @action.bound
    public getAllObservationTypes(pageNumber?: number, pageSize?: number) {
        if (!pageNumber) {
            pageNumber = 1;
        }
        if (!pageSize) {
            pageSize = 25;
        }
        this.isLoading = true;
        return this.client
            .getAllObservationTypes(undefined, pageNumber, pageSize)
            .then((resp: SwaggerResponse<IObservationTypeDto[]>) =>
                runInAction(() => {
                    this.observationTypes = this.setupObservationTypes(resp.result);
                })
            );
    }

    private setupObservationTypes = (observationTypes: IObservationTypeDto[]) => {
        return observationTypes.map((x) => this.addDefaultFields(x));
    };

    private addDefaultFields = (observationType: IObservationTypeDto): IObservationType => {
        return { ...DefaultObservationType(), ...observationType };
    };
}



// WEBPACK FOOTER //
// ./src/stores/ObservationsStore/ObservationTypesStore.ts